import { EJavaClassNames } from '@adaptiva/data-service';
import { IconProperties, MetadataSerialization } from '@adaptiva/metadata/common';
import { FileUploaderComponent } from '@adaptiva/widgets/file-uploader';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-icon-properties',
	templateUrl: './icon-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconPropertiesComponent extends BaseAuthoringPropertiesComponent<IconProperties> {

	private static readonly ICO_PREFIX: string = 'data:image/x-icon;base64,';

	private static readonly PREFIX: RegExp = new RegExp('^[^;]*;base64,');

	public propertyConstructor: MetadataSerialization.Deserializable<IconProperties> = IconProperties;

	public iconUrl$: BehaviorSubject<string> = new BehaviorSubject('');

	public maxIconSize: int = (1024 ** 2) / 4 * 3; // 1MB max icon size

	protected readonly softwareIconClassName: EJavaClassNames = EJavaClassNames.SoftwareIcon;

	public override commitModelToView(): void {
		if (this.currentPropertyObject?.CompressedData)
			this._updateIcon(this.currentPropertyObject.CompressedData);
	}

	public setIconFile(_event: FileUploaderComponent.IContent): void {
		let _data: string = null;

		if (_event.stringContent?.length) {
			_data = _event.stringContent[0];

			if (IconPropertiesComponent.PREFIX.test(_data))
				_data = _data.split(IconPropertiesComponent.PREFIX).pop();
		}

		this.setObjectPropertyValue('CompressedData', _data);
		this._updateIcon(_data);
	}

	private _updateIcon(_data: string): void {
		if (!_data)
			this.iconUrl$.next(null);
		else
			this.iconUrl$.next(IconPropertiesComponent.ICO_PREFIX + _data);
	}

}
